import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

/**
 * Realça placeholders não preenchidos no documento — trechos entre colchetes,
 * ex.: [NOME DO AUTOR], [Data por extenso], [INSERIR VALOR]. Ajuda o advogado a
 * ver de imediato o que falta preencher. Apenas decoração visual: NÃO altera o
 * conteúdo salvo do documento.
 *
 * Regex: colchetes contendo letra/maiúscula/underscore, 2 a 60 chars, sem
 * colchetes aninhados. Cobre [CAMPO], [Campo Composto], [INSERIR X].
 */
export const PLACEHOLDER_REGEX = /\[[^\]\n]{2,60}\]/g

export const placeholderHighlightKey = new PluginKey('placeholderHighlight')

function buildDecorations(doc: any): DecorationSet {
  const decorations: Decoration[] = []
  doc.descendants((node: any, pos: number) => {
    if (!node.isText || !node.text) return
    const text: string = node.text
    let m: RegExpExecArray | null
    PLACEHOLDER_REGEX.lastIndex = 0
    while ((m = PLACEHOLDER_REGEX.exec(text)) !== null) {
      const from = pos + m.index
      const to = from + m[0].length
      decorations.push(
        Decoration.inline(from, to, {
          class: 'ap-placeholder',
          style:
            'background-color: #fff3b0; border-radius: 3px; padding: 0 2px; ' +
            'box-shadow: inset 0 -1px 0 #f0c000;',
        })
      )
    }
  })
  return DecorationSet.create(doc, decorations)
}

/** Conta placeholders no documento atual (para a status bar / checklist). */
export function countPlaceholders(html: string): string[] {
  if (!html) return []
  const text = html.replace(/<[^>]+>/g, ' ')
  const matches = text.match(PLACEHOLDER_REGEX) || []
  return matches
}

export const PlaceholderHighlight = Extension.create({
  name: 'placeholderHighlight',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: placeholderHighlightKey,
        state: {
          init: (_: any, { doc }: any) => buildDecorations(doc),
          apply: (tr: any, old: DecorationSet) =>
            tr.docChanged ? buildDecorations(tr.doc) : old,
        },
        props: {
          decorations(state: any) {
            return this.getState(state)
          },
        },
      }),
    ]
  },
})

export default PlaceholderHighlight
